import React from "react";
import CallIcon from "@mui/icons-material/Call";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import { Card, CardContent } from "@mui/material";

function StudentSupport() {
  const contacts = [
    { number: "08188959522" },
    { number: "08035031558" },
  ];

  return (
    <div className="min-h-screen w-full flex justify-center items-center bg-gray-100 py-10 px-4">
      <Card className="max-w-xl w-full rounded-3xl shadow-2xl border border-gray-200">
        <div className="bg-blue-900 text-white text-center py-5 px-3 rounded-t-3xl shadow-md">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-wide">Student Support</h2>
          <p className="text-sm opacity-90 mt-1">Call or Chat on WhatsApp</p>
        </div>

        <CardContent className="p-6 sm:p-8 space-y-6 bg-white rounded-b-3xl">
          {contacts.map((c, i) => (
            <div
              key={i}
              className="flex items-center justify-between bg-gray-100 p-4 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition duration-200"
            >
              <div className="flex items-center gap-3">
                <CallIcon className="text-blue-900 text-xl" />
                <p className="text-lg font-semibold text-gray-700">{c.number}</p>
              </div>

              {/* WhatsApp Button */}
              <a
                href={`https://wa.me/234${c.number.substring(1)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 shadow"
              >
                <WhatsAppIcon /> Chat
              </a>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}

export default StudentSupport;